import React from 'react'

import { colors } from '../../theme'

export function CloseOption() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={colors.grey900}
        fillRule="evenodd"
        d="M6.47 6.47a.75.75 0 011.06 0l10 10a.75.75 0 11-1.06 1.06l-10-10a.75.75 0 010-1.06z"
        clipRule="evenodd"
      />
      <path
        fill={colors.grey900}
        fillRule="evenodd"
        d="M17.53 6.47a.75.75 0 010 1.06l-10 10a.75.75 0 01-1.06-1.06l10-10a.75.75 0 011.06 0z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export function IconCancelarBaixa() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={colors.errorText}
        fillRule="evenodd"
        d="M6.47 6.47a.75.75 0 011.06 0l10 10a.75.75 0 11-1.06 1.06l-10-10a.75.75 0 010-1.06z"
        clipRule="evenodd"
      />
      <path
        fill={colors.errorText}
        fillRule="evenodd"
        d="M17.53 6.47a.75.75 0 010 1.06l-10 10a.75.75 0 01-1.06-1.06l10-10a.75.75 0 011.06 0z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export function CloseProductDetailsPredictions() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={colors.white}
        fillRule="evenodd"
        d="M6.47 6.47a.75.75 0 011.06 0l10 10a.75.75 0 11-1.06 1.06l-10-10a.75.75 0 010-1.06z"
        clipRule="evenodd"
      />
      <path
        fill={colors.white}
        fillRule="evenodd"
        d="M17.53 6.47a.75.75 0 010 1.06l-10 10a.75.75 0 01-1.06-1.06l10-10a.75.75 0 011.06 0z"
        clipRule="evenodd"
      />
    </svg>
  )
}
